// extracted by mini-css-extract-plugin
export default {"container":"yo-z","ratingLayout":"zo-z","ratingLabel":"Ao-z","nonInteractiveRatingLabel":"Bo-z"};